import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Volkshotel = ({featuredProjectsList}) => {
  const project = getProject('volkshotel');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            posterVideo: '216718748'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Your Majesty was invited to design and build an online platform for
            Volkshotel, a new hotel and entertainment establishment in Amsterdam
            East.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503205726/01b.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The building, which once housed a popular newspaper, now hosts 172
            hotel rooms, two restaurants, two nightclubs and 70 creative studios
            and has established itself as a hub for artists and makers. We
            created a custom platform to house every aspect under one roof.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503205728/03.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Since the hotel has so many interesting facets, thanks to the
            diversity of tenants and the building’s rich history, we decided to
            approach the project from a heritage point of view. As such, we
            applied a publishing platform solution rather than a traditional
            hotel booking structure.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503205727/02b.jpg'
          }}
        />

        <Quote
          className="g-row quote--marks"
          component={{
            quote: 'A dedicated team who asks difficult questions and brings fresh perspectives to our business. A great partner that is a blast to work with.',
            quotee: 'José Dol, General Manager, Volkshotel'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Together with the Volkshotel team, we created a framework that
            provides tenants space to express themselves, while still living
            within the Volkshotel brand. We also invited six local artists to
            create 15-second video loops that serve as section headers on the
            site.
          </p>
        </AnimateIn>

        <VimeoVideo
          className="component--no-margin"
          component={{
            posterVideo: '216718832'
          }}
        />

        <VimeoVideo
          className="component--no-margin"
          component={{
            posterVideo: '216718888'
          }}
        />

        <Image
          component={{
            image: '//images.yourmajesty.co/20170509195302/00_case_Volks.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>21% increase in booked rooms</li>
            <li>65,000 unique monthly visitors</li>
            <li>4% bounce rate</li>
            <li>Avg. time on site 2.5 min</li>
          </ul>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="collaborators">Collaborators</h2>
          <p>
            Gijs Kast
            <br />
            Muller Van Tol
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Content Strategy',
                  'Interviews & User Testing',
                  'Launch Strategy',
                  'Research',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'Illustration',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Booking Engine',
                  'Content Management System',
                  'Front-end Development',
                  'Functional Prototyping'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Optimization',
                  'Quality Assurance',
                  'Quantitative and Qualitative Analysis',
                  'Staff Training & Support'
                ]
              },

              {
                title: 'Content',
                items: ['Animation']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'http://volkshotel.nl/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Volkshotel;
